import { NavigateFunction } from './types'
import { throwIf } from './utils/errors'
import {
  getPanelTop,
  popFromPanel,
  pushToPanel,
  replaceInPanel,
} from './service'

export const navigateFactory: (panel: string) => NavigateFunction = (
  panel: string,
) => (to, { data, replace, absolute } = {}) => {
  if (typeof to === 'number') {
    throwIf(
      to >= 0,
      'value of "to" provided to navigate function should not be a number greater or equal to zero.',
    )

    for (let i = 0; i < -to; i++) popFromPanel(panel)
  } else {
    const topLocation = getPanelTop(panel)?.location
    const newLocation = absolute
      ? to
      : topLocation
      ? [topLocation].concat(to).join('/')
      : to

    if (replace) replaceInPanel(panel, newLocation, data)
    else pushToPanel(panel, newLocation, data)
  }
}
